// Action Types
export const GET_UNREAD_NOTIFICATIONS_REQUEST = 'GET_UNREAD_NOTIFICATIONS_REQUEST';
export const GET_UNREAD_NOTIFICATIONS_SUCCESS = 'GET_UNREAD_NOTIFICATIONS_SUCCESS';
export const GET_UNREAD_NOTIFICATIONS_FAIL = 'GET_UNREAD_NOTIFICATIONS_FAIL';

export const GET_RECENT_NOTIFICATIONS_REQUEST = 'GET_RECENT_NOTIFICATIONS_REQUEST';
export const GET_RECENT_NOTIFICATIONS_SUCCESS = 'GET_RECENT_NOTIFICATIONS_SUCCESS';
export const GET_RECENT_NOTIFICATIONS_FAIL = 'GET_RECENT_NOTIFICATIONS_FAIL';

export const GET_UNREAD_COUNT_REQUEST = 'GET_UNREAD_COUNT_REQUEST';
export const GET_UNREAD_COUNT_SUCCESS = 'GET_UNREAD_COUNT_SUCCESS';
export const GET_UNREAD_COUNT_FAIL = 'GET_UNREAD_COUNT_FAIL';

export const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAIL = 'MARK_NOTIFICATION_AS_READ_FAIL';

export const MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST = 'MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST';
export const MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS = 'MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS';
export const MARK_ALL_NOTIFICATIONS_AS_READ_FAIL = 'MARK_ALL_NOTIFICATIONS_AS_READ_FAIL';

// Action Creators
export const getUnreadNotificationsRequest = (userId, roleId, moduleId) => ({
    type: GET_UNREAD_NOTIFICATIONS_REQUEST,
    payload: { userId, roleId, moduleId }
});

export const getUnreadNotificationsSuccess = (notifications) => ({
    type: GET_UNREAD_NOTIFICATIONS_SUCCESS,
    payload: notifications
});

export const getUnreadNotificationsFail = (error) => ({
    type: GET_UNREAD_NOTIFICATIONS_FAIL,
    error
});

export const getRecentNotificationsRequest = (userId, roleId, moduleId) => ({
    type: GET_RECENT_NOTIFICATIONS_REQUEST,
    payload: { userId, roleId, moduleId }
});

export const getRecentNotificationsSuccess = (notifications) => ({
    type: GET_RECENT_NOTIFICATIONS_SUCCESS,
    payload: notifications
});

export const getRecentNotificationsFail = (error) => ({
    type: GET_RECENT_NOTIFICATIONS_FAIL,
    error
});

export const getUnreadCountRequest = (userId, roleId, moduleId) => ({
    type: GET_UNREAD_COUNT_REQUEST,
    payload: { userId, roleId, moduleId }
});

export const getUnreadCountSuccess = (count) => ({
    type: GET_UNREAD_COUNT_SUCCESS,
    payload: count
});

export const getUnreadCountFail = (error) => ({
    type: GET_UNREAD_COUNT_FAIL,
    error
});

export const markNotificationAsReadRequest = (id) => ({
    type: MARK_NOTIFICATION_AS_READ_REQUEST,
    payload: { id }
});

export const markNotificationAsReadSuccess = (id) => ({
    type: MARK_NOTIFICATION_AS_READ_SUCCESS,
    payload: { id }
});

export const markNotificationAsReadFail = (error) => ({
    type: MARK_NOTIFICATION_AS_READ_FAIL,
    error
});

export const markAllNotificationsAsReadRequest = (userId, roleId, moduleId) => ({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
    payload: { userId, roleId, moduleId }
});

export const markAllNotificationsAsReadSuccess = () => ({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS
});

export const markAllNotificationsAsReadFail = (error) => ({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_FAIL,
    error
});
